import { IconHorizontal, IconVertical, Props } from "./MoreIcon.Parts";

export const MoreIcon = ({ small, horizontal, ...props }: Props) => {
  if (horizontal)
    return (
      <IconHorizontal
        viewBox="0 0 21 5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        $small={small}
        {...props}
      >
        <path
          d="M21 4.11883L21 0.881169C21 0.394513 20.6082 9.00815e-07 20.125 8.79692e-07L16.875 7.3763e-07C16.3918 7.16506e-07 16 0.394513 16 0.881169L16 4.11883C16 4.60549 16.3918 5 16.875 5L20.125 5C20.6082 5 21 4.60549 21 4.11883Z"
          fill="currentColor"
        />
        <path
          d="M13 4.11883L13 0.881169C13 0.394513 12.6082 9.00815e-07 12.125 8.79692e-07L8.875 7.3763e-07C8.39175 7.16506e-07 8 0.394513 8 0.881169L8 4.11883C8 4.60549 8.39175 5 8.875 5L12.125 5C12.6082 5 13 4.60549 13 4.11883Z"
          fill="currentColor"
        />
        <path
          d="M5 4.11883L5 0.881169C5 0.394513 4.60825 9.00815e-07 4.125 8.79692e-07L0.875 7.3763e-07C0.391751 7.16506e-07 2.01312e-07 0.394513 1.8004e-07 0.881169L3.85172e-08 4.11883C1.72448e-08 4.60549 0.391751 5 0.875 5L4.125 5C4.60825 5 5 4.60549 5 4.11883Z"
          fill="currentColor"
        />
      </IconHorizontal>
    );

  return (
    <IconVertical
      viewBox="0 0 5 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      $small={small}
      {...props}
    >
      <path
        d="M4.11883 0H0.881168C0.394512 0 0 0.391751 0 0.875V4.125C0 4.60825 0.394512 5 0.881168 5H4.11883C4.60549 5 5 4.60825 5 4.125V0.875C5 0.391751 4.60549 0 4.11883 0Z"
        fill="currentColor"
      />
      <path
        d="M4.11883 8H0.881168C0.394512 8 0 8.39175 0 8.875V12.125C0 12.6082 0.394512 13 0.881168 13H4.11883C4.60549 13 5 12.6082 5 12.125V8.875C5 8.39175 4.60549 8 4.11883 8Z"
        fill="currentColor"
      />
      <path
        d="M4.11883 16H0.881168C0.394512 16 0 16.3918 0 16.875V20.125C0 20.6082 0.394512 21 0.881168 21H4.11883C4.60549 21 5 20.6082 5 20.125V16.875C5 16.3918 4.60549 16 4.11883 16Z"
        fill="currentColor"
      />
    </IconVertical>
  );
};
